import React, { useEffect, useMemo, useState } from 'react';
import './RetailerKpiDrillDown.scss';
import { useDispatch, useSelector } from 'react-redux';
import { IAppState } from 'store';
import { CheckBox } from 'components/CheckBox';
import TableLoader from 'components/TableLoader';
import { SelectComponent } from '../../../SelectComponent';
import {
  setRetailerKpiDrillDownSelectedParts,
  getRetailerKpiTopFarmers,
  getRetailerKpi,
  setRetailerFilterSpecies,
  setRetailerFilterProcessor,
  setRetailerFilterProject, setRetailerKpiDrillDownSelectedPartsClear,
} from 'store/retailerKpi/actions';
import { GraphDataModel } from '../FarmerKpiGeneralTab/types';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { labelsForRetailerDrillGraph } from '../RetailerKpiGeneralTab';
import { TableFilter } from '../../../TableFilter';
import { TableSelect } from '../../../TableSelect';
import { formatDate } from '../../../../services';
import { TableStub } from '../../../TableStub';
import { useHistory } from 'react-router';
import { ROUTES } from '../../../../config/routes';
import { useTranslation } from 'react-i18next';
import { getReportsInfo } from '../utils';

interface IGraphInterface {
  data: Array<GraphDataModel>;
  heading: string;
  id: number;
}

const RetailerKpiDrillDownTab = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [selectedTopFarmersId, setSelectedTopFarmersId] = useState<
    number | null
  >(null);
  const {
    isLoading,
    drillDownSelectedParts,
    topFarmersData,
    topFarmersLoading,
    sortDescending,
    sortKey,
    filter,
    dataListDrill,
    filteredSpecies,
    filteredProject,
    filteredProcessor,
  } = useSelector((state: IAppState) => state.retailerKpi);
  const [speciesList, setSpeciesList] = useState([]);
  const { t, i18n } = useTranslation();

  const [processorList, setProcessorList] = useState([]);

  const [projectList, setProjectList] = useState([]);
  const [checkboxValue, setCheckboxValue] = useState([]);
  const [showCheckbox, setShowCheckbox] = useState(false);
  const userRole = useSelector(
    (state: IAppState) => state.auth.profile?.UserRoleName,
  );
  const isProcessor = userRole === "Processor";

  useEffect(() => {
    setSpeciesList(filteredSpecies);
    setProjectList(filteredProject);
    setProcessorList(filteredProcessor);
  }, [filteredSpecies, filteredProcessor, filteredProject])

  useEffect(() => {
    getReportsInfo();
    return () => {
      // resetFilterHandler()
    }
  }, [])



  const resetFilterHandler = () => {
    dispatch(setRetailerKpiDrillDownSelectedPartsClear())
    dispatch(setRetailerFilterSpecies([]));
    dispatch(setRetailerFilterProject([]))
    dispatch(setRetailerFilterProcessor([]))
    setShowCheckbox(false)
    setSelectedTopFarmersId(null);
    dispatch(getRetailerKpiTopFarmers({ selectedKpis: [] }));
    // dispatch(setRetailerKpiDrillDownSelectedPartsClear())
  }

  const searchHanler = () => {
    const data = {
      selectedFarmers: [speciesList],
      selectedProcessors: processorList.map(item => item.value),
      selectedProjects: projectList.map(item => item.value),
    }
    dispatch(getRetailerKpi(data));
    setShowCheckbox(true);
  }

  const assessment = useMemo(() => {
    let result = {
      AssessmentParts: []
    }
    if (
      speciesList &&
      dataListDrill?.KpiDataModels
    ) {
      dataListDrill?.KpiDataModels.forEach(a => {
        a.AssessmentParts.forEach(aPart =>
          result.AssessmentParts.push({ ...aPart, farmerName: a.FarmerName, id: a.AssessmentID, AssessmentDate: a.AssessmentDate }),
        );
      });
    }
    return result;
  }, [
    speciesList,
    processorList,
    projectList,
    dataListDrill,
  ]);
  useEffect(() => {
    let obj = {};
    let result = [];
    assessment?.AssessmentParts?.forEach(ass => {
      obj[ass?.Name] = ass?.KPI_ID
    })
    for (const [key, value] of Object.entries(obj)) {
      result.push({ Name: key, KPI_ID: value })
    }
    setCheckboxValue(result);
    if (result[0]?.KPI_ID) {
      dispatch(setRetailerKpiDrillDownSelectedPartsClear());
      dispatch(setRetailerKpiDrillDownSelectedParts(result[0]?.KPI_ID));
      if (result[1]?.KPI_ID) dispatch(setRetailerKpiDrillDownSelectedParts(result[1]?.KPI_ID));
      if (result[2]?.KPI_ID) dispatch(setRetailerKpiDrillDownSelectedParts(result[2]?.KPI_ID));
    } else dispatch(setRetailerKpiDrillDownSelectedPartsClear())

  }, [assessment])


  const dataForGraphs: Array<IGraphInterface> = drillDownSelectedParts.map(
    part => {
      let dataToShow = [];

      const assPart = assessment?.AssessmentParts?.find(p => p.KPI_ID === part);
      const assPartFarmers = assessment?.AssessmentParts?.filter(p => p.KPI_ID === part);
      if (assPart?.Values.length > 0 && assPart?.Values[0]) {
        for (const [key, value] of Object.entries(assPart?.Values[0])) {
          if (labelsForRetailerDrillGraph[key]) {
            dataToShow = [
              ...dataToShow,
              {
                name: `${labelsForRetailerDrillGraph[key]}`,
                value: value ? +Number(value).toFixed(2) : 0,
              },
            ];
          }
        }
        assPartFarmers.forEach((ass, idx) => {
          if (ass.farmerName) {
            dataToShow = [
              ...dataToShow,
              {
                name: `${ass.farmerName}, ${formatDate(ass.AssessmentDate, 'MM D, YYYY')}`,
                value: ass?.Values[0].Value ? +Number(ass?.Values[0].Value).toFixed(2) : 0,
              },
            ];
          }
        })

      }
      return {
        heading: `${assPart?.Name}${assPart?.UnitPostFix ? ', ' + assPart?.UnitPostFix : ''}`,
        data: dataToShow,
        id: assPart?.KPI_ID,
      };
    },
  );


  const onFarmersChange = (farmer: any) => {
    setSpeciesList(farmer.value);
    dispatch(setRetailerFilterSpecies(farmer.value));
  };

  const onProjectsChange = (project: any) => {
    setProjectList(project);
    dispatch(setRetailerFilterProject(project))
  };

  const onProcessorChange = (processor: any) => {
    dispatch(setRetailerFilterProcessor(processor))
    setProcessorList(processor);
  };

  const onChangeKpiValue = (kpiId: number) => {
    dispatch(setRetailerKpiDrillDownSelectedParts(kpiId));
  };

  const onTopFarmersClick = (id: number) => {
    setSelectedTopFarmersId(id);
    dispatch(getRetailerKpiTopFarmers({ selectedKpis: [id] }));
  };

  const dispatchGetFarmersWithFilters = (additionalFilter: any) => {
    dispatch(
      getRetailerKpiTopFarmers({
        sortKey,
        filter,
        selectedKpis: [selectedTopFarmersId],
        ...additionalFilter,
      }),
    );
  };

  const onFarmNameSort = () => {
    dispatchGetFarmersWithFilters({
      sortKey: 'FarmName',
      sortDescending: !sortDescending,
    });
  };

  const onFarmerNameSort = () => {
    dispatchGetFarmersWithFilters({
      sortKey: 'FarmerName',
      sortDescending: !sortDescending,
    });
  };

  const onIndexSort = () => {
    dispatchGetFarmersWithFilters({
      sortKey: 'Co2Index',
      sortDescending: !sortDescending,
    });
  };

  const onAssessmentSort = () => {
    dispatchGetFarmersWithFilters({
      sortKey: 'LastAssessment',
      sortDescending: !sortDescending,
    });
  };

  const onLocationSortFilter = (location: string) => {
    dispatchGetFarmersWithFilters({ filter: location, sortKey: null });
  };

  const onLocationDiscard = () => {
    dispatchGetFarmersWithFilters({ location: null });
  };

  let locationOptions = useMemo(() => {
    let set: Set<string> = new Set();
    topFarmersData.forEach(f => set.add(f?.Location));
    return Array.from(set).map(v => ({ value: v, label: v }));
  }, [topFarmersData]);

  const onGoToFarmerKpi = farmerInfo => {
    history.push(ROUTES.retailerFarmerKpi, farmerInfo);
  };
  return (
    <div
      className="tab-pane"
      id="drill-down"
      role="tabpanel"
      aria-labelledby="certificates-tab"
    >
      {isLoading ? (
        <TableLoader />
      ) : (
        <>
          <div className="chart-filter">
            <div className="kpi-row kpi-row-md">
              <div className="kpi-item">
                <div className="form-group">
                  <SelectComponent
                    options={dataListDrill?.SpeciesFilterValues?.map(f => ({
                      value: f,
                      label: f,
                    }))}
                    value={speciesList}
                    label={t('AD_Select species')}
                    onChange={onFarmersChange}
                  />
                </div>
              </div>
              <div className="kpi-item">
                <div className="form-group">
                  <SelectComponent
                    isMulti
                    options={dataListDrill?.ProjectFilterValues?.map(f => ({
                      value: f,
                      label: f,
                    }))}
                    value={projectList}
                    label={t('AD_Select project')}
                    onChange={onProjectsChange}
                  />
                </div>
              </div>
              {!isProcessor && <div className="kpi-item">
                <div className="form-group">
                  <SelectComponent
                    isMulti
                    options={dataListDrill?.ProcessorFilterValues?.map(f => ({
                      value: f,
                      label: f,
                    }))}
                    value={processorList}
                    label={t('RM_proc')}
                    onChange={onProcessorChange}
                  />
                </div>
              </div>}
              <div className="action-row-btn">
                <button className="btn action-primary" onClick={resetFilterHandler}>{t('RM_reset')}</button>
                <button
                  className="btn action-primary"
                  onClick={searchHanler}
                  disabled={!speciesList.length}
                >{t('AD_Search')}</button>
              </div>
            </div>
            {(!showCheckbox || checkboxValue.length === 0) && <h1 className={"empty-msg"}>{t('AD_Your search returned no results')}</h1>}
            <div className="filter-checkboxes">
              <div className="checkboxes-row">
                {showCheckbox && checkboxValue.map(assPart => (
                  <CheckBox
                    key={assPart.KPI_ID}
                    isSelected={drillDownSelectedParts?.some(
                      p => p === assPart.KPI_ID,
                    )}
                    label={assPart.Name}
                    onChange={() => {
                      onChangeKpiValue(assPart.KPI_ID);
                    }}
                    name={`${assPart.Name.replace(' ', '')}${assPart.KPI_ID}`}
                  />
                ))}
              </div>
            </div>
          </div>
          <div className="chart-wrapper">
            <div className="drilldown-charts">
              {showCheckbox && dataForGraphs?.length > 0 &&
                dataForGraphs.map(data => (
                  <div className="drilldown-chart" key={data.heading}>
                    <h2 className="chart-heading heading-small">
                      {data.heading}
                    </h2>
                    <ResponsiveContainer
                      width="100%"
                      height={data.data.length * 55}
                    >
                      <BarChart
                        layout="vertical"
                        data={data.data}
                        margin={{
                          top: 5,
                          right: 30,
                          left: 20,
                          bottom: 5,
                        }}
                      >
                        <CartesianGrid
                          strokeDasharray="0 0"
                          horizontal={false}
                          vertical={false}
                        />
                        <XAxis type="number" />
                        <YAxis
                          dataKey="name"
                          type="category"
                          scale="band"
                          width={120}
                        />
                        <Tooltip />
                        <Bar
                          dataKey="value"
                          barSize={14}
                          radius={[0, 10, 10, 0]}
                          background={{ fill: '#edf0f1' }}
                        >
                          {data.data.map(d => {
                            return (
                              <Cell
                                fill={'#37a041'}
                                key={d.name}
                                onClick={onTopFarmersClick.bind(null, data.id)}
                                stroke={'#37a041'}
                                strokeWidth={0}
                              />
                            )
                          })}
                          <LabelList
                            dataKey="value"
                            position="right"
                            width={100}
                            style={{ fill: '#000' }}
                          />
                        </Bar>
                      </BarChart>
                    </ResponsiveContainer>
                  </div>
                ))}
            </div>
          </div>
        </>
      )}
      {topFarmersLoading ? (
        <TableLoader />
      ) : speciesList &&
        topFarmersData.length && selectedTopFarmersId && showCheckbox ? (
        <div className="custom-table processor-suppliers-table retailer-farmers-table">
          <div className="table-header">
            <div className="farm-wrapper">
              <TableFilter
                active={sortKey === 'FarmName' && sortDescending}
                text={t('AD_Farm name')}
                onSort={onFarmNameSort}
              />
            </div>
            <div className="farmer-wrapper">
              <TableFilter
                active={sortKey === 'FarmerName' && sortDescending}
                text={t('AD_Farmer name')}
                onSort={onFarmerNameSort}
              />
            </div>
            <div className="location-wrapper">
              <TableSelect
                value={filter}
                defaultValue={t('AD_Location')}
                onChange={onLocationSortFilter}
                disabled={false}
                options={locationOptions}
                discardFilter={onLocationDiscard}
              />
            </div>
            <div className="last-assessment-wrapper">
              <TableFilter
                onSort={onAssessmentSort}
                active={sortKey === 'LastAssessment' && sortDescending}
                text={t('AD_Last assessment')}
              />
            </div>
            <div className="index-wrapper">
              <TableFilter
                onSort={onIndexSort}
                active={sortKey === 'Co2Index' && sortDescending}
                text={t('AD_CO2 index')}
              />
            </div>
            <div className="system-type-wrapper">
              <span>
                {
                  assessment?.AssessmentParts.find(
                    a => a.KPI_ID === selectedTopFarmersId,
                  )?.Name
                }
              </span>
            </div>
            <div className="action-wrapper">{t('AD_Action')}</div>
          </div>
          <div className="table-body">
            {topFarmersData.map(farmer => (
              <div className="table-item" key={farmer.FarmerID}>
                <div className="farm-wrapper">
                  <span>{farmer.FarmName}</span>
                </div>
                <div className="farmer-wrapper">
                  <span>{farmer.FarmerName}</span>
                </div>
                <div className="location-wrapper">
                  <span>{farmer.Location}</span>
                </div>
                <div className="last-assessment-wrapper">
                  <span>
                    {formatDate(farmer.LastAssessment, 'MMMM D, YYYY')}
                  </span>
                </div>
                <div className="index-wrapper">
                  <span>{farmer.Co2Index}</span>
                </div>
                <div className="system-type-wrapper">
                  <span>{farmer?.AssessmentParts?.[0].Value}</span>
                </div>
                <div className="action-wrapper">
                  <button
                    className="action-primary btn table-action-btn"
                    onClick={onGoToFarmerKpi.bind(null, farmer)}
                  >
                    {t('AD_View')}
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : selectedTopFarmersId ? (
        <TableStub description={t('AD_Your search returned no results')} />
      ) : null}
    </div>
  );
};

export { RetailerKpiDrillDownTab };
